;
/*!
 * subitotexto.pointage-tabs.js
 */


SubitoTexto.pointageTabs = {
	init: function () {
		var $ = jqPla,
			_this = SubitoTexto.pointageTabs;

		_this.$pointageMain = $( '.jeux-pointage' );

		if ( _this.$pointageMain.length < 1 ) {
			return;
		}

		_this.$tabGroups = _this.$pointageMain.find( '.tabs' );
		_this.$radios = _this.$pointageMain.find( '.state' );
		_this.$labels = _this.$pointageMain.find( '.tab' );


		_this.$panels = _this.$pointageMain.find('.panel');
		_this.$panelBlocks = _this.$panels.find('a');

		_this.bindEvents();
	},

	bindEvents: function () {
		var $ = jqPla,
			_this = SubitoTexto.pointageTabs;

// add remove classes and the aria-selected attribute
		_this.$radios.on( 'change', function ( e ) {

			var $this = $( this ),
				$siblings = $this.siblings( '.state' ),
				id = $this.attr( 'id' ),
				$partnerLabel = _this.$labels.filter( '[for="' + id + '"]' ),
				$tabGroup = $partnerLabel.parents( '.tabs' );


			//console.log( $this, id, $partnerLabel, $tabGroup );

			$siblings
				.removeAttr( 'aria-selected' )
				.removeClass( 'active' );

			$this
				.attr( 'aria-selected', 'true' )
				.addClass( 'active' );

		} );


		// Surround the active tab when focussed for a11y
		_this.$radios.on( 'focus', function ( e ) {
			var $this = $( this ),
				id = $this.attr( 'id' ),
				$partnerLabel = _this.$labels.filter( '[for="' + id + '"]' ),
				$tabGroup = $partnerLabel.parents( '.tabs' );

			_this.$tabGroups.not($tabGroup).removeClass('active');

			$tabGroup.addClass('active');

		} );

		// Once we exit the panels with the tabs, we want to remove the yellow a11y contour
		_this.$panelBlocks.on('focus', function(e) {
			_this.$tabGroups.removeClass('active');
		});
	}

}